import { ReactElement, ReactNode } from 'react';

interface SettingsHeaderProps {
  title: string;
  icon: ReactElement;
  children?: ReactNode;
}

const SettingsHeader = ({ title, icon, children }: SettingsHeaderProps) => {
  return (
    <div className="mb-6 flex min-h-12 flex-col gap-3 border-b border-gray-300 pb-4 font-bold text-xl sm:flex-row sm:items-center sm:justify-between">
      <div className="flex min-w-0 items-center gap-2">
        {icon}
        <span className="min-w-0">{title}</span>
      </div>

      {children && (
        <div className="flex flex-wrap items-center gap-2 text-sm font-medium sm:justify-end">
          {children}
        </div>
      )}
    </div>
  );
};

export default SettingsHeader;
